/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmailType } from './EmailType';
import {
    EmailTypeFromJSON,
    EmailTypeFromJSONTyped,
    EmailTypeToJSON,
    EmailTypeToJSONTyped,
} from './EmailType';

/**
 * 
 * @export
 * @interface RecordEmailSentRequest
 */
export interface RecordEmailSentRequest {
    /**
     * 
     * @type {string}
     * @memberof RecordEmailSentRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof RecordEmailSentRequest
     */
    resendId?: string;
    /**
     * 
     * @type {EmailType}
     * @memberof RecordEmailSentRequest
     */
    emailType: EmailType;
    /**
     * 
     * @type {number}
     * @memberof RecordEmailSentRequest
     */
    bookingId?: number;
    /**
     * 
     * @type {Date}
     * @memberof RecordEmailSentRequest
     */
    sentAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof RecordEmailSentRequest
     */
    errorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordEmailSentRequest
     */
    errorMessage?: string;
}



/**
 * Check if a given object implements the RecordEmailSentRequest interface.
 */
export function instanceOfRecordEmailSentRequest(value: object): value is RecordEmailSentRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('emailType' in value) || value['emailType'] === undefined) return false;
    return true;
}

export function RecordEmailSentRequestFromJSON(json: any): RecordEmailSentRequest {
    return RecordEmailSentRequestFromJSONTyped(json, false);
}

export function RecordEmailSentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordEmailSentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'resendId': json['resend_id'] == null ? undefined : json['resend_id'],
        'emailType': EmailTypeFromJSON(json['email_type']),
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'sentAt': json['sent_at'] == null ? undefined : (new Date(json['sent_at'])),
        'errorCode': json['error_code'] == null ? undefined : json['error_code'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
    };
}

export function RecordEmailSentRequestToJSON(json: any): RecordEmailSentRequest {
    return RecordEmailSentRequestToJSONTyped(json, false);
}

export function RecordEmailSentRequestToJSONTyped(value?: RecordEmailSentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'resend_id': value['resendId'],
        'email_type': EmailTypeToJSON(value['emailType']),
        'booking_id': value['bookingId'],
        'sent_at': value['sentAt'] == null ? value['sentAt'] : value['sentAt'].toISOString(),
        'error_code': value['errorCode'],
        'error_message': value['errorMessage'],
    };
}

